// Tracks requests in flight. A write identical to one still pending (same
// method, URL and body) gets the pending promise instead of a second send, so a
// double tap reaches the dock once. Requests a person started (not background
// ones) count toward busy, which turns on only after delayMs so fast replies
// show nothing.
export function writeKey(method, url, body) {
	if (method === "GET") { return null; }
	return method + " " + url + " " + (body === undefined ? "" : JSON.stringify(body));
}

export function createInflight(onBusy, delayMs) {
	var writes = new Map();
	var count = 0;
	var timer = null;
	var busy = false;

	function setBusy(v) {
		if (busy !== v) { busy = v; onBusy(v); }
	}

	function finish() {
		count--;
		if (count > 0) { return; }
		if (timer) { clearTimeout(timer); timer = null; }
		setBusy(false);
	}

	return {
		run: function (key, background, send) {
			if (key && writes.has(key)) { return writes.get(key); }
			var p = send();
			if (key) {
				writes.set(key, p);
				p.then(() => writes.delete(key), () => writes.delete(key));
			}
			if (!background) {
				count++;
				if (!busy && !timer) {
					timer = setTimeout(() => { timer = null; if (count > 0) { setBusy(true); } }, delayMs ?? 300);
				}
				p.then(finish, finish);
			}
			return p;
		},
	};
}
